import React, { useState } from "react";
import axios from 'axios';
import "../../styles/pages-styles/landing-layout-pages-styles/SignUp.css";
import { useNavigate } from "react-router-dom";

const SignUp = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [agreeToTerms, setAgreeToTerms] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();


  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(""); // Reset error message
    setLoading(true);



    // Basic validation

    if (!firstName || !lastName || !email || !password || !confirmPassword) {

      setError("All fields are required.");

      setLoading(false);

      return;
    }



    if (password !== confirmPassword) {

      setError("Passwords do not match.");

      setLoading(false);

      return;
    }

     if (password.length < 8) {

        setError("Password must be at least 8 characters long");

        setLoading(false);

        return;
    }



    if (!agreeToTerms) {

      setError("Please agree to the Terms and Conditions and Privacy Policy.");

      setLoading(false);

      return;
    }



    // Email validation (basic)

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(email)) {

        setError("Invalid email address");

        setLoading(false);

        return;
    }





    try {

      // Make the Axios POST request

      const response = await axios.post(

        "/user/signup", // Replace with your backend API endpoint

        {

          firstName: firstName,
          lastName: lastName,

          email: email,

          password: password,

        },

        {

          headers: {

            "Content-Type": "application/json",

          },

        }
      );



      // Handle successful response

      console.log("Sign up successful!", response.data);

      //  Redirect to login page or show success message

      navigate("/login")

      // window.location.href = '/login'; //if you have a login route



      // Reset the form

      setFirstName("");
      setLastName("");

      setEmail("");

      setPassword("");

      setConfirmPassword("");

      setAgreeToTerms(false);



    } catch (error) {

      // Handle error (e.g., display error message)

      console.error("Sign up failed:", error);

      if (error.response && error.response.data && error.response.data.message) {

        setError(error.response.data.message);

      } else {

        setError("An error occurred during sign up. Please try again.");
      }
    } finally {

      setLoading(false);
    }
  };



  return (

    <div>

      <div className="signup-container">

        <div className="signup-card">

          {/* Logo and Header */}

          <div className="header">

            <h1 className="logo">

              Qbank<span className="logo-highlight">360</span>

            </h1>

            <p className="subtitle">Create your account</p>

          </div>



          {/* Form */}

          <form className="signup-form" onSubmit={handleSubmit}>

            {/* First Name */}

            <div className="form-group">

              <label htmlFor="firstName">First Name</label>

              <input

                type="text"

                id="firstName"

                name="firstName"

                value={firstName}

                onChange={(e) => setFirstName(e.target.value)}

                placeholder="Enter your first name"

                required

              />

            </div>
            {/* Last Name */}
            <div className="form-group">
              <label htmlFor="lastName">Last Name</label>
              <input
                type="text"
                id="lastName"
                name="lastName"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                placeholder="Enter your last name"
                required
              />
            </div>


            {/* Email */}

            <div className="form-group">

              <label htmlFor="email">Email Address</label>

              <input

                type="email"

                id="email"

                name="email"

                value={email}

                onChange={(e) => setEmail(e.target.value)}

                placeholder="you@example.com"

                required

              />

            </div>



            {/* Password */}

            <div className="form-group">

              <label htmlFor="password">Password</label>

              <input

                type="password"

                id="password"

                name="password"

                value={password}

                onChange={(e) => setPassword(e.target.value)}

                placeholder="Create a password"

                required

                minLength={8}

              />

            </div>



            {/* Confirm Password */}

            <div className="form-group">

              <label htmlFor="confirmPassword">Confirm Password</label>

              <input

                type="password"

                id="confirmPassword"

                name="confirmPassword"

                value={confirmPassword}

                onChange={(e) => setConfirmPassword(e.target.value)}

                placeholder="Confirm your password"

                required

                minLength={8}

              />

            </div>



            {/* Terms and Conditions */}

            <div className="form-group-checkbox">

              <input

                id="agreeToTerms"

                name="agreeToTerms"

                type="checkbox"

                checked={agreeToTerms}

                onChange={(e) => setAgreeToTerms(e.target.checked)}

                required

              />

              <label htmlFor="agreeToTerms">

                I agree to the{" "}

                <a href="#" className="link">

                  Terms and Conditions

                </a>{" "}

                and{" "}

                <a href="#" className="link">

                  Privacy Policy

                </a>

              </label>

            </div>

             {error && <p className="error-message">{error}</p>}

            {/* Submit Button */}

            <button type="submit" className="submit-button" disabled={loading}>

              {loading ? "Loading..." : "Create Account"}

            </button>



            {/* Login Link */}

            <div className="login-link">

              <p>

                Already have an account?{" "}
                <a href="login" className="link">
                  Log in

                </a>

              </p>

            </div>

          </form>

        </div>

      </div>

    </div>

  );
};



export default SignUp;
